export enum INTEGRATION_STATUS {
  NOTINSTALLED = "notinstalled",
  REQUESTED = "requested",
  INSTALLED="installed"
}
